import {Component, computed, inject, input} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {StoryblokService} from '@core/services/storyblok.service';
import {Maybe, ProductAuthor} from '@core/interfaces/generated/graphql';

@Component({
  selector: 'app-product-author',
  templateUrl: './product-author.component.html',
  styleUrls: ['./product-author.component.scss'],
  imports: [
    NgOptimizedImage
  ]
})
export class ProductAuthorComponent {
  protected storyblokService = inject(StoryblokService);

  productAuthor = input<Maybe<ProductAuthor> | undefined>()
  onlyBottomBorder = input<boolean>(false);

  getAuthorImage = computed(() => {
    if (!this.productAuthor()?.image) {
      return {imgWidth: 675, imgHeight: 675, optimizedUrl: ''};
    }
    return this.storyblokService.getImageObject({filename: this.productAuthor()?.image ?? ''}, 120, 120);
  });
}

